import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from 'primereact/button';
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../../Base/Context/ConfigContext/ConfigContext";

// ------------------- CONSULTAS A LA API---------------------------
import {ObtenerSalidasT, SalidasParaDevoluciones } from "../../../../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import AgregarDevolucionInterna from "./AgregarDevolicionInterna";
import RequisaMaterialCrud from "../../RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";
import IngresosBodegaCrud from "../../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";
import CalendarWeek from "../../../../../../Base/Components/Form/CalendarWeek";
import { getDatesProduccion } from "../../../../../../Base/Services/Moment/Luxon";

const ListadoDevolucionesInternasCRUD = ({
    actualizarScreen,
  }) => {
    const toastRef = useRef(null);
    const { userAuth } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]); 
    const [showDialogDI, setShowDialogDI] = useState(false);
    const [showDialogRM, setShowDialogRM] = useState(false);
    const [showDialogI, setShowDialogI] = useState(false);
    const [listadoI, setListadoI] = useState(null);  
    const [ingresoToShow, setIngresoToShow] = useState(null);
    const [requisaToShow, setRequisaToShow] = useState(null);
    const [habilitar, setHabilitar] = useState(true);
    const { config } = useContext(ConfigContext);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const toast = useRef(null);
  


    const getInfoCrud = async () => {
      if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
        toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
        return;
      }
      setLoading(true)
      const fechas = getDatesProduccion(dates);
      const lista = await SalidasParaDevoluciones(fechas)
      setListadoI(lista)
      setLoading(false)
    };
  
    const columns = [
      {
        // Comment
        field: "IdSalidaDetalle",
        header: "ID",
        headerEn: "ID",
        className: "XXsmall",
        frozen: "frozen",
        hidden: userAuth.IdRol === 1,
        // onCellDoubleClicked: ({ data }) => {
        //   setShowDialogSalida(true);
        //   setSelected(data);
        // },
  
      },
      {
        // Comment
        field: "FechaSalida",
        header: "Fecha de Salida",
        headerEn: "Departure Date",
        className: "colum-width-medium",
        body: (rowData) => rowData.FechaDet,
        frozen: "frozen",
        Format: "DateTime2",
        
      },
      {
        header: "Estado",
        headerEn: "Status",
        field: "StatusName",
        frozen: true,
        className: "small",
        Format: "Estado",
        body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
        
      },
      {
        // PurchaseRequest
        field: "Requisa",
        headerEn: "No. Material Requisition",
        header: "No. Requisa Material",
        className: "small",
        body: (rowData) => rowData.Requisa,
        Format: "Modal",
        align: "center",
        Sumary: "count",
        frozen: "frozen",
        onCellDoubleClicked: ({ data }) => {
          RequisaM(data.Requisa);
        },
      },
      // {
      //   // PurchaseRequest
      //   field: "NumeroIngreso",
      //   headerEn: "Entry Number",
      //   header: "No. NumeroIngreso",
      //   className: "colum-width-medium",
      //   body: (rowData) => rowData.NumeroIngreso,
      //   Format: "Modal",
      //   align: "center",
      //   Sumary: "count",
      //   onCellDoubleClicked: ({ data }) => {
      //     Ingreso(data.NumeroIngreso);
      //   },
      // },
      {
        // Comment
        field: "CodigoProducto",
        header: "Codigo Producto",
        headerEn: "Product Code",
        className: "small",
      },
      {
        // Comment
        field: "NombreProducto",
        header: "Nombre Producto",
        headerEn: "Product Name",
        className: "colum-width-Xlarge",
      },
      {
        // Comment
        field: "UnitName",
        header: "Unidad",
        headerEn: "Unit",
        className: "Xsmall",
      },
      {
        // Comment
        field: "NombreTipoProducto",
        header: "Tipo Producto",
        headerEn: "Product Type",
        className: "small",
      },
      {
        // Comment
        field: "Area",
        header: "Area",
        headerEn: "Area",
        className: "small",
      },
      {
        // Comment
        field: "ComentarioRequisa",
        header: "Comentario Requisa",
        headerEn: "Comment Requisition",
        className: "medium",
      },
      {
        // Comment
        field: "UserNameDespacho",
        header: "Usuario Despacho",
        headerEn: "Usuario Despacho",
        className: "medium",
      },
      {
        header: "Inventario",
        headerEn: "Amount",
        field: "Inventario",
        className: "Xsmall",
        Format: "Currency",
        frozen: true,
        Sumary: 'sum',
        alignFrozen: 'right'
      },
      {
        header: "Cant. Solicitada",
        headerEn: "Amount",
        field: "Qty",      
        className: "Xsmall",
        Format: "Currency",
        frozen: true,
        Sumary: 'sum',
        alignFrozen: 'right'
      },
      {
        header: "Cant. Despachada",
        headerEn: "Amount",
        field: "QtySalida",
        className: "Xsmall",
        Format: "Currency",
        frozen: true,
        alignFrozen: 'right',
        Sumary: 'sum'
      },
      {
        header: "Balance",
        headerEn: "Balance",
        field: "BalanceDevolucion",
        className: "Xsmall",
        Format: "Currency",
        frozen: true,
        Sumary: 'sum',
        alignFrozen: 'right'
      },
      {
        field: "",
        className: "colum-width-small",
        header: "",
        Format: "Botones",
        filter: false,
        frozen: true,
        alignFrozen: "right",
        Botones: [
          {
            icon: "pi pi-plus",
            tooltip: "Agregar Salida",
            onClick: (rowData) => {
              if(rowData?.IdSalidaDetalle){
                setShowDialogDI(true);
                setSelected([rowData]);
              }
            },
            tooltipOptions: {
              position: "right",
            },
          },
        ],
      },
    ];
  
    const table = {
      Columns: columns,
      Data: listadoI,
      loading: loading,
      selected: selected,
      setSelected: (e) => setSelected(e),
      showModal: (e) => showModal(e),
    };

    const cerrarConfirmacion = () => {
      // Mostrar confirmación si hay ediciones sin guardar
      if (habilitar && requisaToShow !== null) {
        confirmDialog({
          message: "¿Estás seguro de cerrar sin guardar los cambios?",
          header: "Cerrar sin guardar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sí",
          accept: () => {
            setShowDialogRM(null);
            setRequisaToShow(null); // Cerrar el diálogo
          },
          rejectLabel: "No",
          reject: () => {}, // No hacer nada si el usuario cancela
          style: { backgroundColor: "white" },
        });
      } else {
        setShowDialogRM(null);
        setRequisaToShow(null);
        setHabilitar(true);
      }
    };

    const cerrarConfirmacionI = () => {
      // Mostrar confirmación si hay ediciones sin guardar
      if (habilitar && ingresoToShow !== null) {
        confirmDialog({
          message: "¿Estás seguro de cerrar sin guardar los cambios?",
          header: "Cerrar sin guardar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sí",
          accept: () => {
            setShowDialogI(null);
            setIngresoToShow(null); // Cerrar el diálogo
          },
          rejectLabel: "No",
          reject: () => {}, // No hacer nada si el usuario cancela
          style: { backgroundColor: "white" },
        });
      } else {
        setShowDialogI(null);
        setIngresoToShow(null);
        setHabilitar(true);
      }
    };


    const showModal = (tipoModal) => {
      if (tipoModal === 'ingreso') {
        setShowDialogI(true); 
      } else if (tipoModal === 'requisaMaterial') {
        setShowDialogRM(true); 
      }
    };
  
    const Ingreso = (Id) => {
      setIngresoToShow(Id);
      setShowDialogI(true);
      // showModal('ingreso'); 
    };
    
    const RequisaM = (Id) => {
      setRequisaToShow(Id);
      setShowDialogRM(true)
      showModal('requisaMaterial'); 
    };

      useEffect(() => {
        getInfoCrud();
      }, []);
    
    
    return (
      <div>
        <Toast ref={toast} />
        <div className="d-flex gap-2 m-2">
          <h2>{getLabel(baseLang, "listadoDeSalidas", config.language)}</h2>

          <div className="botones">
            <CalendarWeek
              date={dates}
              setDate={setDates}
              buscar={getInfoCrud}
              selectionMode="range"
            />

            <Button
              icon="pi pi-plus"
              className="mx-2"
              tooltip="Nueva"
              onClick={(e) => {
                if (selected.length === 0) {
                  toastShow(
                    toastRef,
                    "warn",
                    "Advertencia",
                    "Seleccione una Salida"
                  );
                  return;
                } else {
                  setShowDialogDI(true);

                  // if (selected.length > 1) {
                  //   toastShow(
                  //     toastRef,
                  //     "warn",
                  //     "Advertencia",
                  //     "Seleccione solo una salida"
                  //   );
                  //   return;
                  // } else {
                  //   setShowDialogDI(true);
                  // }
                }
              }}
            />
          </div>
        </div>

        <div style={{ height: "76vh" }}>
          <Loader loading={loading}></Loader>
          <AgGrid table={table} />
        </div>

        {showDialogDI && (
          <AgregarDevolucionInterna
            selected={selected}
            setSelected={setSelected}
            showDialogDI={showDialogDI}
            setShowDialogDI={setShowDialogDI}
            getInfo={getInfoCrud}
            actualizarScreen={actualizarScreen}
            // SalidaDet={selected[0] || selected}
          />
        )}

        <Dialog
          visible={showDialogRM}
          onHide={() => {
            cerrarConfirmacion();
          }}
          maximized={true}
          maximizable={true}
          closeOnEscape={false}
        >
          <RequisaMaterialCrud
            idIngreso={requisaToShow}
            setIngresoToShow={setRequisaToShow}
            showDialog={showDialogRM}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
          />
        </Dialog>


        <Dialog
        visible={showDialogI}
        onHide={() => {
          cerrarConfirmacionI();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialogI}
          // actualizarIngresosScreen={actualizarIngresosScreen}
          // actualizarIngresosScreenListado={actualizarIngresosScreenListado}
          // setOrderToShow={setOrderToShow}
          // setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>
      </div>
    );
  };
  
  export default ListadoDevolucionesInternasCRUD;
  
